function normalizeInvite (invite) {
  const flows = invite.flow.flows

  let responsible
  if (invite.responsibles) {
    if (invite.responsibles.length > 1) {
      flows.forEach(flow => {
        const responsibleStep = flow.steps.find(step => step.type === 'responsible')
        if (responsibleStep) {
          responsibleStep.responsibles = invite.responsibles.map(person => ({
            name: person.name.trim(), email: person.email.trim()
          })).filter((person, index, self) => 
            index === self.findIndex(p => p.email === person.email)
          )
        }
      })
    } else {
      responsible = invite.responsibles[0].email
      flows.forEach(flow => {
        flow.steps = flow.steps.filter(step => step.type !== 'responsible')
      })
    }
  }

  return {
    inviteId: invite.inviteId,
    private: invite.private,
    flows: invite.flow.flows,
    theme: invite.flow.settings,
    responsible,
  }
}

function normalizeResponse (inviteData, inviteResponse) {
  let responses = []
  const arr = ([ ...inviteResponse.values() ])
  arr.forEach(stepResponses => responses = [ ...responses, ...stepResponses.values() ])

  let identification = {}
  responses.filter(res => res.type === 'identification')
    .forEach(({ value }) => identification = { ...identification, ...value })
  
  let personalData = {}
  responses.filter(res => res.type === 'personalData')
    .forEach(({ value }) => personalData = { ...personalData, ...value })

  let additionalData = {}
  if (inviteData.responsible) {
    additionalData.responsible = inviteData.responsible
  } else {
    const responsibleResponse = responses.find(res => res.type === 'responsible')
    if (responsibleResponse && responsibleResponse.value && responsibleResponse.value.responsible) {
      additionalData.responsible = responsibleResponse.value.responsible
    }
  }

  let acceptedPrivacyTerms
  const privacyTerm = responses.find(res => res.type === 'terms')
  if (privacyTerm && privacyTerm.value && privacyTerm.value.publicDocumentId) {
    acceptedPrivacyTerms = privacyTerm.value.publicDocumentId
  }

  let acceptedDocuments = []
  responses.filter(res => res.type === 'document')
    .forEach(({ value }) => acceptedDocuments.push(value.documentId))

  const { value: { reserveId, inviteKey, email }} = responses.find(res => res.type === 'welcome')

  let photo
  const picture = responses.find(res => res.type === 'picture')
  if (picture && picture.value && picture.value.image) {
    photo = picture.value.image
  }

  const inviteId = inviteData.inviteId
  const normalized = {
    inviteInfo: {
      inviteId, inviteKey, reserveId, email
    },
    guest: {
      identification,
      personalData,
      additionalData,
      acceptedDocuments,
      acceptedPrivacyTerms
    },
    photo
  }
  
  return normalized
}

export {
  normalizeInvite,
  normalizeResponse
}